import { Tooltip } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import CountdownTimer from 'src/components/common/CountdownTimer';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { RootState } from 'src/types/store-types';
import './styles.scss';

type ISafeDataType = {
  id: number;
  name: string;
  image: string;
  description: string;
  lastRenew?: {
    date?: string | null;
    time?: string | null;
  };
  passwordChangeTime?: string | null;
};

type IProps = {
  classname?: string;
  data?: ISafeDataType;
  onOpenSafe: (...args: any) => void;
};

const SafeCard: FC<IProps> = ({ classname, data, onOpenSafe }) => {
  const { t }: Translation = useTranslation();

  const user = useSelector((state: RootState) => state.user?.user);

  return (
    <div className={cn('safe_card', classname)}>
      <div className="safe_card_image_container">
        <img src={data?.image} alt={data?.name} className="safe_card_image" />
      </div>
      <div className="safe_card_description">
        <div className="safe_card_description_header">
          <div className="safe_card_name">
            <h3>{data?.name}</h3>
            {data?.description ? (
              <Tooltip placement="top" title={data.description}>
                <div>
                  <SvgIcon src="/images/icons/svg/circle-exclamation-solid.svg" size="md" color="primaryText" />
                </div>
              </Tooltip>
            ) : null}
          </div>
          {!!user && !!data?.passwordChangeTime && (
            <div className="safe_card_password_change_time">
              <CountdownTimer
                showDays={false}
                size="sm"
                targetDate={(data?.passwordChangeTime as string) ?? ''}
                classname="safe_card_password_change_time_countdown"
              />
            </div>
          )}
        </div>
        <div className="safe_card_last_renew">
          <h4 className="safe_card_last_renew_title">{t('lastRenew')}</h4>
          <div className="safe_card_last_renew_date">
            <div className="safe_card_last_renew_date_row">
              <dt className="safe_card_last_renew_date_row_title">{t('date')}</dt>
              <dd className="safe_card_last_renew_date_row_value">
                {!!user && !!data?.lastRenew?.date
                  ? dayjs(data.lastRenew.date).format('DD.MM.YYYY')
                  : dayjs().format('DD.MM.YYYY')}
              </dd>
            </div>
            <div className="safe_card_last_renew_date_row">
              <dt className="safe_card_last_renew_date_row_title">{t('time')}</dt>
              <dd className="safe_card_last_renew_date_row_value">
                {!!user && data?.lastRenew?.time ? data?.lastRenew?.time : dayjs().format('HH:mm')}
              </dd>
            </div>
          </div>
        </div>
        <div className="safe_card_open_button_container">
          <Button size="md" className="primary-filled-btn" onClick={onOpenSafe}>
            {t('openNow')}
          </Button>
          {user && (
            <div className="safe_card_open_button_notification">
              <span>{1}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default SafeCard;
